
import { call, put, select, takeEvery } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getPurchaseOrderTypes from '../../services/purchaseOrderType/getPurchaseOrderTypes'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchPurchaseOrderTypeCombo () {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    let combo = yield call(getPurchaseOrderTypes, auth.token)
    yield put(fetchCombosSuccess({ purchaseOrderTypeCombo: combo }))
  } catch (error) {
    const sessionHandler = function * () {
      // yield put(reset('conditionsMaintenanceForm'))
    }
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler, sessionHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchPurchaseOrderTypeCombo () {
  yield takeEvery(combosActionTypes.FETCH_PURCHASE_ORDER_TYPE_COMBO, fetchPurchaseOrderTypeCombo)
}
